/**
 * Minimal utilities used by the filter components.
 *
 * Trimmed-down version of Horizon's utilities.js (799 lines → ~25 lines).
 * Only exports what facets.js and component.js actually need.
 */

/**
 * Cross-browser requestIdleCallback (falls back to setTimeout).
 * @type {typeof window.requestIdleCallback}
 */
export const requestIdleCallback =
  typeof window.requestIdleCallback === 'function' ? window.requestIdleCallback : setTimeout;

/**
 * Debounce a function: delays calling `fn` until `wait` ms have passed without a new call.
 * The returned function exposes a `.cancel()` method to clear any pending invocation.
 *
 * @template {(...args: any[]) => any} F
 * @param {F} fn
 * @param {number} wait
 * @returns {F & { cancel: () => void }}
 */
export function debounce(fn, wait) {
  /** @type {ReturnType<typeof setTimeout> | undefined} */
  let timeout;

  function debounced(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  }

  debounced.cancel = () => clearTimeout(timeout);

  return /** @type {F & { cancel: () => void }} */ (debounced);
}
